
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Watch, Prop } from 'vue-property-decorator';

import { dateToString } from './../../nmb/util';

@Component({
  components: { }
})
export default class NoticeAndDocList extends Vue {
  dateToString: Function = dateToString;

  @Prop() item: {[key: string]: any};
  @Prop() searchKey: string;
  @Prop() docProductOptions: Array<{[key: string]: any}>;
  @Prop() highlightKeyword: Function;

  replaceStr(Description: string) {
    const reg = /<\/?.+?\/?>|&nbsp;|&lt;|&gt;/g;

    const content = Description && Description.replace(reg, '') || '';

    return content || '';
  }

  toDetail() {
    const { Id, Type, Title, ProductName, ProductVersion } = this.item;
    const productItem = this.docProductOptions.filter((product: any) => product.Title === ProductName);
    if (Type === 'News') {
      this.$router.push({ path: `/home/noticeDetail/${Id}` });
    } else if (Type === 'Documents') {
      this.$router.push({
        path: '/documents/docreview',
        query: {
          id: productItem.length ? productItem[0].ID : '',
          docid: Id,
          title: ProductName,
          ver: ProductVersion
        }
      });
    }
  }
}
